import { Asterisk } from "lucide-react";

const ITEMS = [
  "Abertura de Empresa",
  "Regularização de CNPJ",
  "Consultoria Tributária",
  "Imposto de Renda",
  "Contabilidade Mensal",
  "Pró-labore",
  "Legalização",
  "Abertura MEI",
];

export default function Marquee() {
  const row = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex items-center shrink-0">
      {ITEMS.map((item) => (
        <span key={item + (ariaHidden ? "-b" : "-a")} className="flex items-center">
          <span className="font-display font-bold uppercase tracking-tight text-2xl md:text-4xl px-6 md:px-10 whitespace-nowrap">
            {item}
          </span>
          <Asterisk className="text-ink/60 shrink-0" size={28} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="services-marquee"
      className="relative bg-crimson text-paper border-y border-crimson-deep py-6 overflow-hidden"
    >
      <div className="marquee-track flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
